import React, {useContext} from 'react';
import {boxStyles, colors, textSizes} from "../../styles/theme";
import {css} from "emotion";
import headerInfo from "./data/headerInfo";
import {BuildContext} from "../../context/BuildSpotlightState";

const TitleBlock = () => {
  const { stage } = useContext(BuildContext);

  return (
    <div className={container}>
      <h3>{headerInfo[stage].title}</h3>
      <p>{headerInfo[stage].subtitle}</p>
    </div>
  );
};

export default TitleBlock;

const container = css`
  max-width: 500px;
  width: 100%;
  text-align: left;
  margin-bottom: 30px;
  margin-top: 10px;
  
  h3 {
    color: ${colors.titleColor};
    font-size: ${textSizes.title};
  }
  
  p {
    color: ${colors.subtitleColor};
    font-size: ${textSizes.subtitle};
  }
    
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    margin-top: 60px;
  }
`;
